import createErrorType from 'app/utils/createErrorType';

export class NonCriticalError extends createErrorType('NonCriticalError') {}
